/** Border shown on light swatches and gradient previews so they remain visible on white UI surfaces. */
export const SWATCH_BORDER_CLASS =
  'border border-[var(--modus-wc-color-base-200,#e0e1e9)]';

const LIGHT_SWATCH_COLORS = new Set(['#ffffff', '#fff', 'white']);

export function isLightSwatchColor(color: string): boolean {
  return LIGHT_SWATCH_COLORS.has(color.trim().toLowerCase());
}

export function stopsContainLightColor(
  stops: readonly { readonly color: string }[]
): boolean {
  return stops.some((stop) => isLightSwatchColor(stop.color));
}
